var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticStyle:{"width":"100%"}},[(!_vm.isLoading)?_c('div',[_c('LineChart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOption,"height":_vm.chartHeight}})],1):_c('div',{staticStyle:{"text-align":"center"}},[_c('b-spinner',{staticClass:"align-middle mr-2"}),_c('strong',[_vm._v("กำลังโหลดข้อมูล...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }